import { leaveTypes } from '../../../../lib/apiList'
import axios from '../../../../lib/axios'
import {
    CreateLeaveTypeRequest,
    GetLeaveTypesRequest,
    UpdateLeaveTypesRequest,
} from './types'

export const createLeaveType = (body: CreateLeaveTypeRequest): Promise<any> => {
    const response = axios.post(leaveTypes.CREATE_LEAVE_TYPES, body)
    return response
}

export const getLeaveTypes = (body: GetLeaveTypesRequest): Promise<any> => {
    const response = axios.post(leaveTypes.GET_LEAVE_TYPES, body)
    return response
}

export const updateLeaveTypes = (
    body: UpdateLeaveTypesRequest
): Promise<any> => {
    const response = axios.post(leaveTypes.EDIT_LEAVE_TYPES, body)
    return response
}

export const deleteLeaveTypes = (leaveTypeId: string): Promise<any> => {
    const url = leaveTypes.DELETE_LEAVE_TYPES
    const response = axios.delete(url, { data: { leaveTypeId } })
    return response
}
